/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Code_ColInputs */

const en_admin_invite_codes_code_col = /** @type {(inputs: Admin_Invite_Codes_Code_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

const zh_admin_invite_codes_code_col = /** @type {(inputs: Admin_Invite_Codes_Code_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请码`)
};

/**
* | output |
* | --- |
* | "Code" |
*
* @param {Admin_Invite_Codes_Code_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_code_col = /** @type {((inputs?: Admin_Invite_Codes_Code_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Code_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_code_col(inputs)
	return zh_admin_invite_codes_code_col(inputs)
});
export { admin_invite_codes_code_col as "admin.invite_codes.code_col" }